import type { FetchParams, PaginatedResponse } from "@nuxt/app";
import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  LessonPlanListResponse,
  LessonPlanRetrieveResponse,
} from "~/types/admin/content/lesson_plans";

class AdminContentLessonPlansModule extends HttpFactory {
  async getLessonPlans(
    fetchParams: FetchParams,
  ): Promise<PaginatedResponse<LessonPlanListResponse>> {
    return await this.get(
      `${ENDPOINTS.ADMIN.CONTENT.LESSON_PLANS}`,
      fetchParams,
    );
  }

  async getLessonPlan(
    lessonPlanId: string,
  ): Promise<LessonPlanRetrieveResponse> {
    return await this.get(
      `${ENDPOINTS.ADMIN.CONTENT.LESSON_PLANS}${lessonPlanId}/`,
    );
  }

  async patchLessonPlan(
    lessonPlanId: string,
    payload: any,
  ): Promise<LessonPlanRetrieveResponse> {
    return await this.patch(
      `${ENDPOINTS.ADMIN.CONTENT.LESSON_PLANS}${lessonPlanId}/`,
      payload,
    );
  }

  async postLessonPlan(payload: any): Promise<LessonPlanRetrieveResponse> {
    return await this.post(`${ENDPOINTS.ADMIN.CONTENT.LESSON_PLANS}`, payload);
  }

  async deleteLessonPlan(lessonPlanId: string): Promise<void> {
    return await this.delete(
      `${ENDPOINTS.ADMIN.CONTENT.LESSON_PLANS}${lessonPlanId}/`,
    );
  }
}

export { AdminContentLessonPlansModule };
